import { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

interface WPCategory {
  id: number;
  name: string;
  slug: string;
}

interface BlogHeaderProps {
  currentTitle?: string; // Optional single post title (won’t replace main header)
  currentCategorySlug?: string; // Active pill
}

export default function BlogHeader({ currentTitle, currentCategorySlug }: BlogHeaderProps) {
  const [allCategories, setAllCategories] = useState<WPCategory[]>([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch('https://blog.thecryptotutor.com/wp-json/wp/v2/categories?per_page=100');
        const data: WPCategory[] = await res.json();
        setAllCategories([{ id: 0, name: 'All', slug: 'all' }, ...data]);
      } catch (err) {
        console.error('Failed to fetch categories:', err);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="bg-[#F5F7FA]">
      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center space-x-2 text-sm text-gray-500">
            <Link to="/" className="hover:text-blue-600 transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/categories" className="hover:text-blue-600 transition-colors">Categories</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">{currentTitle || 'Crypto Tutor Blog'}</span>
          </nav>
        </div>
      </div>

      {/* Category Header */}
      <div className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Always use main title */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Crypto Tutor Blog</h1>

          {/* Optional description could go here if needed */}
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-6"></p>

          {/* Category Pills */}
          <div className="flex justify-center flex-wrap gap-2 p-4">
            {allCategories.map((cat) => {
              const isActive = currentCategorySlug
                ? currentCategorySlug === cat.slug
                : location.search.includes(cat.slug) || (!location.search && cat.slug === 'all');

              return (
                <button
                  key={cat.id}
                  onClick={() => {
                    if (cat.slug === 'all') navigate('/blog');
                    else navigate(`/category/${cat.slug}`);
                  }}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-blue-500 text-white'
                      : 'bg-gray-100 text-gray-800 hover:bg-blue-100 hover:text-blue-700'
                  }`}
                >
                  {cat.name}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
